module.exports = __webpack_public_path__ + "img/gris-4.5aeb3db6.png";